
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/note",
      function () {
        return require("private-next-pages/note.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/note"])
      });
    }
  